<mat-dialog-content class="exams-dialog setup">
  <div (click)="showPrevStep()" class="step-container assessment_mt-25  cursor-pointer" *ngIf="!data?.isExamEdit || data?.setupAccountImposed">
    <img src="assets/img/back-arrow-icon-dark.svg" class="back"><div class="step">STEP 3/3</div>
  </div>

  <div class="heading">
    {{ data?.message }}
  </div>
  <div class="info-div">
    {{data?.message2}}
  </div>


    <input type="text" class="form-control search" placeholder="Search exam name" (keyup)="searchExams($event)">

    <div class="exams-box assessment_pt-20">
      <div class="exam-box {{selectedExams[i] ? 'selected': ''}}" *ngFor="let i of searchIndices" (click)="selectExam(i)">
        
          <img class="icon-24 assessment_mr-8 mid-img" [src]="exams[i]?.image" alt="">

          <div style="width: 158px; margin-right: auto;">
            <div class="exam-name">
              {{exams[i]?.name}}
            </div>
            <div class="exam-desc">
              {{exams[i]?.description}}
            </div>
          </div>
          <img src="{{selectedExams[i] ? greenTickPath: greyTickPath}}" class="ml-auto mid-img" />
      </div>
    </div>

  <div class="d-flex align-items-center justify-content-between assessment_mt-25 setup-flex" *ngIf="!data?.isExamEdit">
      <div class="btn btn-primary mweb-width" (click)="navigateBetweenProjects()">
          GET STARTED
      </div>
      <!-- <div class="skip mweb-skip" (click)="goToProfile()">
          SKIP
      </div> -->
  </div>

  <div class="m-bottom-btn d-flex justify-content-md-end assessment_mt-25" *ngIf="data?.isExamEdit">
      <button type="button" class="btn btn-primary btn-save-details" (click)="onConfirmClick()">SAVE PREFERENCE</button>
      <button type="button" style="color: #0C9968;" *ngIf="!data?.setupAccountImposed" class="btn btn-link assessment_mb-0 assessment_pr-30 assessment_pl-30" (click)="onNoClick()">Cancel</button>
  </div>

</mat-dialog-content>
